// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Woe is me, that I must lodge in Meshech&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and dwell among the tents of Kedar.<br> </p> </div></div>";
// Exports
module.exports = code;